import {Inject, Injectable} from '@angular/core';
import {OAuthEvent, OAuthService} from 'angular-oauth2-oidc';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import {environment, CustomEnvironment, setApiOverrides} from '../../environments/environment';
import {Observable} from 'rxjs';
import {catchError, tap, mergeMap} from 'rxjs/operators';
import {HttpErrorHandlerService, HandleError} from './http-error-handling.service';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Authorization': 'my-auth-token'
  })
};

@Injectable()
export class SettlementsService {
  private handleError: HandleError;

  constructor(private oauthService: OAuthService,
              private http: HttpClient,
              httpErrorHandler: HttpErrorHandlerService,
              @Inject(CustomEnvironment) customEnvironment: any) {
    setApiOverrides(customEnvironment);

    this.oauthService.events.subscribe((event: OAuthEvent) => {
      const tokenUpdatedEvents: any = ['token_refreshed', 'token_received', 'silently_refreshed'];
      if (tokenUpdatedEvents.includes(event.type)) {
        httpOptions.headers = httpOptions.headers.set('Authorization', this.oauthService.authorizationHeader());
      }
    });

    httpOptions.headers = httpOptions.headers.set('Authorization', this.oauthService.authorizationHeader());
    this.handleError = httpErrorHandler.createHandleError('SettlementsService');
  }

  /**
   * Prepares the data for bulk pool transfer
   * @param data
   */
  bulkPoolData(upcrDate, effectiveDate, data) {
    return this.http.post<any[]>(`${environment.api.settlement}/pool-transfer/upcr-data?upcr_date=${upcrDate}&effective_date=${effectiveDate}`,  data, httpOptions);
  }

  /**
   * Prepares the data for bulk pool transfer
   * @param data
   */
  bulkPoolDataProcess(data) {
    return this.http.post<any[]>(`${environment.api.settlement}/pool-transfer/upcr-data/process`,  data, httpOptions);
  }
}
